import { createPortal } from 'react-dom';
import { MiniBasket } from '@/components/MiniBasket';
import { usePageData } from '@/contexts/pageContext';
import { useQueryCustomerStatus } from '../useQueryCustomerStatus';

const miniBasketPortal = document.querySelector('.header__main__minibasket');

export const useMiniBasket = () => {
  const { urls } = usePageData();

  const { numberOfItemsInBasket, isPending } = useQueryCustomerStatus();

  return miniBasketPortal && urls.basket
    ? createPortal(
        <MiniBasket
          isPending={isPending}
          link={urls.basket}
          quantity={numberOfItemsInBasket}
        />,
        miniBasketPortal,
      )
    : null;
};
